import { lazyComponent } from '@unisporkal/react-lazy-component';
import { federatedComponent } from '@unisporkal/federation';

export const components = {
  istock: {
    Header: federatedComponent('global_nav', './Header'),
    Footer: federatedComponent('global_nav', './Footer'),
    FourOhFour: lazyComponent(() =>
      import('app/root-components/errors/istock/FourOhFour')
    ),
    FourTen: lazyComponent(() =>
      import('app/root-components/errors/istock/FourTen')
    ),
    SearchBar: lazyComponent(() =>
      import('app/components/shared/SearchBar/SearchBar')
    ),
    InspirePage: lazyComponent(() =>
      import('app/components/istock/InspirePage/InspirePage')
    ),
    VideoEditor: lazyComponent(() =>
      import('app/components/istock/VideoEditor/VideoEditor')
    ),
    VideoLanding: lazyComponent(() =>
      import('app/components/istock/VideoLanding/VideoLanding.tsx')
    ),
    JumpLinksBar: lazyComponent(() =>
      import('app/components/shared/JumpLinksBar/JumpLinksBar')
    ),
    AiUnlimitedBuyCardSection: lazyComponent(() =>
      import(
        'app/components/istock/AiUnlimitedBuyCardSection/AiUnlimitedBuyCardSection'
      )
    ),
    WorkbenchSlot: lazyComponent(() =>
      import('app/components/shared/WorkbenchSlot/WorkbenchSlot.tsx')
    ),
    AIPagesNavBar: lazyComponent(() =>
      import('app/components/shared/AIPagesNavBar/AIPagesNavBar.tsx')
    ),
    FullWidthBannerPriorOutage: lazyComponent(() =>
      import('app/components/shared/FullWidthBanner/FullWidthBanner.tsx')
    ),
    FullWidthBannerDuringOutage: lazyComponent(() =>
      import('app/components/shared/FullWidthBanner/FullWidthBanner.tsx')
    ),
    VideoTemplateLanding: lazyComponent(() =>
      import(
        'app/components/istock/VideoTemplateLanding/VideoTemplateLanding.tsx'
      )
    ),
    HelpCenter: lazyComponent(() =>
      import('app/components/istock/HelpCenter/HelpCenter.tsx')
    ),
  },
  getty: {
    Footer: federatedComponent('global_nav', './Footer'),
    FourOhFour: lazyComponent(() =>
      import('app/root-components/errors/getty/FourOhFour')
    ),
    FourTen: lazyComponent(() =>
      import('app/root-components/errors/getty/FourTen')
    ),
    Home: lazyComponent(() => import('app/components/getty/Home/Home')),
    JumpLinksBar: lazyComponent(() =>
      import('app/components/shared/JumpLinksBar/JumpLinksBar')
    ),
    UnreleasedImagery: lazyComponent(() =>
      import('app/components/getty/UnreleasedImagery/UnreleasedImagery')
    ),
    CreativeImageHome: lazyComponent(() =>
      import('app/components/getty/CreativeImageHome/CreativeImageHome')
    ),
    InspirePage: lazyComponent(() =>
      import('app/components/getty/InspirePage/InspirePage')
    ),
    AIPagesNavBar: lazyComponent(() =>
      import('app/components/shared/AIPagesNavBar/AIPagesNavBar.tsx')
    ),
    AIHeroWithBuyCard: lazyComponent(() =>
      import('app/components/istock/AIHeroWithBuyCard/AIHeroWithBuyCard.tsx')
    ),
    FullWidthBannerPriorOutage: lazyComponent(() =>
      import('app/components/shared/FullWidthBanner/FullWidthBanner.tsx')
    ),
    FullWidthBannerDuringOutage: lazyComponent(() =>
      import('app/components/shared/FullWidthBanner/FullWidthBanner.tsx')
    ),
    VideoTemplateHome: lazyComponent(() =>
      import('app/components/getty/VideoTemplateHome/VideoTemplateHome.tsx')
    ),
    WorkbenchSlot: lazyComponent(() =>
      import('app/components/shared/WorkbenchSlot/WorkbenchSlot.tsx')
    ),
  },
};

export function siteComponent(site, componentName) {
  let component = null;
  const forSite = components[site];
  if (forSite) {
    component = forSite[componentName];
  }
  if (!component) {
    throw new Error(`No component mapped for ${site}:${componentName}`);
  }

  return component;
}

export default siteComponent;
